<template>
  <div id="Admin">

    <p v-if="!ready">{{ $t('message.loading') }}</p>

    <section
      v-if="ready"
      style="padding: 10px;font-size: 13px;">
      <p>Users ({{ users.length }})</p>
      <div class="row mb-3">
        <div class="col-12">
          Sort by
        </div>
        <div class="col-12">
          <button
            :class="[{'active': sort == ''}]"
            type="button"
            class="btn btn-web btn-sm btn-sort"
            @click="sort = ''">
            Latest Joined
          </button>
          <button
            :class="[{'active': sort == '?sortby_latest_active=desc'}]"
            type="button"
            class="btn btn-web btn-sm btn-sort"
            @click="sort = '?sortby_latest_active=desc'">
            Latest Active
          </button>
        </div>
      </div>
      <table
        class="table"
        width="100%">
        <thead>
          <tr>
            <th style="font-size: 13px;">No.</th>
            <th style="font-size: 13px;">Email / Username</th>
            <th style="font-size: 13px;">Type</th>
            <th style="font-size: 13px;">Created</th>
            <th style="font-size: 13px;">Latest Active</th>
            <th style="font-size: 13px;">Verify</th>
            <th
              style="font-size: 13px;"
              width="500">Shops</th>
            <th style="font-size: 13px;">Logs</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(user, index) in users">
            <td>{{ (index+1) }}</td>
            <td>{{ user.email || user.username }}</td>
            <td>{{ user.type }}</td>
            <td>{{ getDateTime(user.created_at) }}</td>
            <td>
              <template v-if="user.analytics.latest_active">
                {{ getFriendlyTime(user.analytics.latest_active) }}
              </template>
            </td>
            <td>{{ user.verify.email }}</td>
            <td>
              <ul v-if="user.shops.length > 0">
                <li
                  v-for="(shop, index_) in user.shops"
                  style="border-bottom: 1px solid #000;">
                  <router-link
                    :to="{
                      name: 'AdminShopInfo',
                      query: {
                        shop_id: shop.shop_id
                      }
                  }">
                    <img
                      :src="shop.logo.thumbnail || 'https://i.imgur.com/obK0kqI.png'"
                      width="35">
                    {{ shop.shop_name }} ({{ shop.shop_id }})
                  </router-link>
                  <br>
                  <template>
                    Installed:
                    <p
                      v-for="(permission, index__) in shop.install_apps"
                      :style="'margin: 0 5px 0 0;background:'+$t(getAppInfo(permission.app_id).translate + '.bgcolor')"
                      class="badge badge-secondary">
                      <i :class="$t(getAppInfo(permission.app_id).translate + '.icon')"/>
                      {{ $t(getAppInfo(permission.app_id).translate + '.title') }}
                    </p>
                  </template>
                </li>
              </ul>
              <span v-else>
                <span v-if="user.employee">
                  <router-link
                    :to="{
                      name: 'AdminShopInfo',
                      query: {
                        shop_id: user.employee.shop_id
                      }
                  }">
                    {{ user.employee.shop_id }}
                  </router-link>
                </span>
              </span>
            </td>
            <td>
              <router-link
                :to="{
                  name: 'AdminUserLog',
                  query: {
                    user_id: user.user_id
                  }
              }">
                View Logs ({{ user.log_count }})
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </section>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'AdminUserAll',
  data () {
    return {
      ready: false,
      sort: '',
    }
  },
  computed: {
    ...mapGetters({
      users: 'getUsers',
      getAppInfo: 'getAppInfo',
    }),
  },
  methods: {
    ...mapActions([

    ]),
    async getUsers (sort) {
      this.ready = false

      let res = await this.$store.dispatch('getUsers', sort)

      this.ready = true
    },
  },
  watch: {
    ready: function (after) {
      if (after == true) {
        // loading finish
        this.showFinish(this.$Progress)
      }
    },
    sort: async function () {
      await this.getUsers(this.sort)
    },
  },
  beforeMount: function () {
    // set section
    this.$store.dispatch('setSection', 'admin')
  },
  created: async function () {
    await this.getUsers(this.sort)
  },
}
</script>

<style scoped>
  .btn-sort {
    opacity: .65;
  }
  .btn-sort.active, .btn-sort:hover {
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/UserAll.vue